// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O9hH","label":"styles_label__20HFe"};